<template>
    <div class="col-md-5">
        <div class="profile__photo">

            <div class="portrait" v-if="artist.file_avatar">
                <img :src="getNameOfAvatar(artist.file_avatar.file_path)" alt="Profile Photo" width="350">
                <a  href="javascript:void(0)"  @click="$refs.imageInput.click()" class="btn btn_primary-outline">Change Cover</a>
            </div>

            <a
                v-else
                href="javascript:void(0)"
                @click="$refs.imageInput.click()"
                class="empty"
            >
                <img
                    src="/img/svg/avatar.svg"
                    aria-hidden="true"
                    width="95"
                >
                <strong>+ Add Cover</strong>
                <p>The image should be in .png, jpg, tiff
                    Not more than 5 MB</p>
            </a>
            <input
                type="file"
                style="display: none"
                @change="onImageSelected"
                ref="imageInput"
                accept="image/*"
            >
        </div>
    </div>

</template>

<script>
import {mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import ArtistService from "../../services/ArtistService";

export default {
    name: 'PortraitEditor',
    emits: ['update-avatar'],
    data() {
        return {
            selectedFile: null,
        }
    },
    computed: {
        ...mapState(useArtistStore, {
            artist: 'artist'
        })
    },



    methods: {
        onImageSelected(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    this.selectedFile = file;
                    this.uploadPhoto();
                };
                reader.readAsDataURL(file);
            }
        },
        getNameOfAvatar(photo) {
            return photo ? `/uploads/${photo}` : "/img/svg/avatar.svg";
        },
        async uploadPhoto() {
            if (this.selectedFile) {
                this.$showLoadingMessage()
                let formData = new FormData();
                formData.append('file', this.selectedFile);
                try {
                    const response = await ArtistService.uploadPhoto(this.artist.id, formData);
                    this.artist.file_avatar = response.data
                    this.$emit('update-avatar', response.data.id)
                    this.$showSuccessMessage('The avatar was updated')
                } catch (e) {
                    console.error(e);
                    this.$showErrorMessage("The photo was not uploaded");
                }
            } else {
                this.$showErrorMessage("Please select photo");
            }
        },
    }
}

</script>


<style scoped>

</style>
